import { CognitoAuth, StorageHelper } from 'amazon-cognito-auth-js'
import IndexRouter from '../router/index'
import UserInfoStore from './user-info-store'
import UserInfoApi from './user-info-api'
import config from '../config'

var auth = new CognitoAuth({
  ClientId: config.COGN_CLIENT_ID, // Your client id here
  AppWebDomain: config.COGN_APP_DOMAIN,
  TokenScopesArray: config.COGN_TOKEN_SCOPE,
  RedirectUriSignIn: config.COGN_CALLBACK_URL,
  RedirectUriSignOut: config.CONG_SIGNOUT_URL,
  UserPoolId: config.COGN_USERPOOL_ID
})
auth.userhandler = {
  onSuccess: _ => {
    console.log('test')
    if (!UserInfoStore.state.loggedIn) {
      UserInfoApi.getUserInfo().then(response => {
        UserInfoStore.setCognitoInfo(response)
        UserInfoStore.setLoggedIn(true)
        if (UserInfoStore.state.userRole == 'tester') {
          IndexRouter.push(config.TESTER_DEFAULT_PATH)
        } else if (UserInfoStore.state.userRole == 'admin') {
          IndexRouter.push(config.ADMIN_DEFAULT_PATH)
        } else {
          IndexRouter.push(config.LOGIN_REDIRECT_URL)
        }
      })
    }
  },
  onFailure: _ => {
    IndexRouter.push('/')
  }
}
auth.useCodeGrantFlow()

var storageHelper = new StorageHelper()
var storage = storageHelper.getStorage()

export default {
  auth: auth,
  login () {
    auth.getSession()
  },
  logout () {
    if (auth.isUserSignedIn()) {
      auth.signOut()
      storage.removeItem(this.getUserInfoStorageKey())
    }
  },
  refresh (doRedirect) {
    UserInfoStore.setLoggedIn(!doRedirect)
    auth.refreshSession(auth.signInUserSession.getRefreshToken().getToken())
  },
  getUserInfoStorageKey () {
    var keyPrefix = 'CognitoIdentityServiceProvider.' + auth.getClientId()
    var tokenUserName = auth.signInUserSession.getAccessToken().getUsername()
    var userInfoKey = keyPrefix + '.' + tokenUserName + '.userInfo'
    return userInfoKey
  }
}
